<device-innobing-config>
  <div class="card h-100 device-detail-support-card">
    <div class="card-header bg-white d-flex justify-content-between align-items-center">
      <span class="fw-semibold">Integración Innobing</span>
      <button
        if={ state.status.innobingEnabled }
        type="button"
        class="btn btn-sm btn-outline-secondary"
        onclick={ handleRefreshStatus }
        disabled={ state.status.loading }
        title="Verificar estado en Innobing">
        <span if={ state.status.loading } class="spinner-border spinner-border-sm me-1" role="status"></span>
        <i if={ !state.status.loading } class="bi bi-arrow-clockwise me-1"></i>
        Verificar
      </button>
    </div>

    <div class="card-body device-detail-support-card-body">

      <!-- Loading -->
      <div if={ state.status.loading } class="d-flex align-items-center gap-2 text-muted">
        <span class="spinner-border spinner-border-sm"></span>
        <span>Consultando Innobing...</span>
      </div>

      <!-- CASO 1: Innobing no activado en la cuenta del propietario (estado terminal) -->
      <div if={ !state.status.loading && state.status.checked && !state.status.innobingEnabled }
           class="alert alert-warning d-flex align-items-center gap-2 mb-0">
        <i class="bi bi-exclamation-triangle-fill"></i>
        <span>El usuario propietario no tiene Innobing activado. Actívalo desde su perfil de usuario.</span>
      </div>

      <!-- Innobing activado: mostramos device_id + estado de enlace -->
      <div if={ !state.status.loading && state.status.checked && state.status.innobingEnabled }>

        <!-- device_id info -->
        <div class="mb-3 p-2 bg-light rounded border d-flex align-items-center gap-2">
          <i class="bi bi-tag text-muted"></i>
          <div>
            <div class="small text-muted">Identificador en Innobing (device_id)</div>
            <code class="fw-semibold">{ props.device._id }</code>
          </div>
        </div>

        <!-- CASO 5: Error al consultar la API de Innobing -->
        <div if={ state.status.error } class="alert alert-danger d-flex align-items-center gap-2 mb-0">
          <i class="bi bi-x-circle-fill"></i>
          <span>{ state.status.error }</span>
        </div>

        <!-- CASO 3: Dispositivo ya enlazado -->
        <div if={ !state.status.error && state.status.registered }>
          <div class="alert alert-success d-flex align-items-center gap-2 mb-0">
            <i class="bi bi-check-circle-fill"></i>
            <span class="fw-semibold">Dispositivo ya enlazado con Innobing.</span>
          </div>
          <div if={ state.status.accessPoint } class="mt-2 ms-1">
            <ul class="list-group list-group-flush small">
              <li each={ entry in getAccessPointEntries() }
                  class="list-group-item px-0 py-1 d-flex gap-2">
                <strong class="text-muted" style="min-width:90px">{ entry[0] }:</strong>
                <span>{ String(entry[1]) }</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- CASO 4: Dispositivo no enlazado -> permitir enlazar -->
        <div if={ !state.status.error && !state.status.registered }>
          <div class="alert alert-warning d-flex align-items-center gap-2">
            <i class="bi bi-exclamation-triangle-fill"></i>
            <span>Dispositivo no enlazado con Innobing. Pulsa el botón para enlazarlo.</span>
          </div>
          <button
            if={ props.isadmin }
            type="button"
            class="btn btn-outline-success"
            onclick={ handleRegister }
            disabled={ state.registering || state.status.loading }>
            <span if={ state.registering } class="spinner-border spinner-border-sm me-1" role="status"></span>
            <i if={ !state.registering } class="bi bi-link-45deg me-1"></i>
            { state.registering ? 'Enlazando...' : 'Enlazar con Innobing' }
          </button>
        </div>
      </div>
    </div>
  </div>

  <script>
    import { DeviceService } from '../services';
    import { ToastService } from '../services/toast-service';

    export default {
      onBeforeMount() {
        this.state = {
          status: {
            loading: false,
            checked: false,
            innobingEnabled: false,
            registered: false,
            accessPoint: null,
            error: null,
          },
          registering: false,
        };
      },

      onMounted() {
        if (this.props.device?._id) {
          this.checkStatus();
        }
      },

      getAccessPointEntries() {
        const accessPoint = this.state.status.accessPoint;
        if (!accessPoint) return [];
        const hidden = ['created_at', 'updated_at'];
        return Object.entries(accessPoint).filter((entry) => !hidden.includes(entry[0]));
      },

      async checkStatus() {
        if (!this.props.device?._id) return;

        this.update({
          status: { ...this.state.status, loading: true, error: null },
        });

        try {
          const result = await DeviceService.getInnobingStatus(this.props.device._id);

          if (result.success) {
            this.update({
              status: {
                loading: false,
                checked: true,
                innobingEnabled: result.innobingEnabled ?? false,
                registered: result.registered ?? false,
                accessPoint: result.accessPoint ?? null,
                error: result.innobingEnabled === false ? (result.error || null) : null,
              },
            });
          } else {
            this.update({
              status: {
                ...this.state.status,
                loading: false,
                checked: true,
                error: result.error || 'Error desconocido',
              },
            });
          }
        } catch (error) {
          this.update({
            status: {
              ...this.state.status,
              loading: false,
              checked: true,
              error: error.message || 'Error al consultar Innobing',
            },
          });
        }
      },

      handleRefreshStatus(e) {
        if (e) e.preventDefault();
        this.checkStatus();
      },

      async handleRegister(e) {
        if (e) e.preventDefault();
        if (this.state.registering || !this.props.device?._id) return;

        this.update({ registering: true });

        try {
          const result = await DeviceService.registerInnobingDevice(this.props.device._id);

          if (result.success) {
            ToastService.show(
              result.message || 'Dispositivo enlazado con Innobing correctamente',
              'success',
            );
            // Refresh status after registration
            await this.checkStatus();
          } else {
            ToastService.show(
              `Error al enlazar: ${result.error || 'Error desconocido'}`,
              'danger',
            );
          }
        } catch (error) {
          ToastService.show(
            `Error al enlazar: ${error.message || 'Error desconocido'}`,
            'danger',
          );
        } finally {
          this.update({ registering: false });
        }
      },
    }
  </script>
</device-innobing-config>
